import React from 'react';
import PropTypes from 'prop-types';
import MultiSelect from './components/multiSelect';

export const WorkArea = ({ onChange, data, jobFunctions, variant }) => (
  <MultiSelect
    initialData={Array.isArray(data) ? data : [data]}
    onChange={(functions) => onChange('jobFunctions', functions)}
    options={jobFunctions}
    type="tag"
    variant={variant}
  />
);

WorkArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  jobFunctions: PropTypes.array.isRequired,
  variant: PropTypes.string,
};

WorkArea.defaultProps = {
  variant: 'onboarding',
};

export default WorkArea;
